/* src/app/modules/shared/components/column/column-helps-with/column-helps-with.component.scss */
app-column-helps-with {
  display: contents;
}
/*# sourceMappingURL=column-helps-with.component.css.map */
